import { render, staticRenderFns } from "./Burger.vue?vue&type=template&id=4214416e"
import script from "./Burger.vue?vue&type=script&lang=js"
export * from "./Burger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports